import React from 'react';
import { FormData } from '../App';
import { Droplets } from 'lucide-react';

interface Props {
  formData: FormData;
  updateFormData: (data: Partial<FormData>) => void;
}

function HerbicideApplications({ formData, updateFormData }: Props) {
  return (
    <div className="space-y-6">
      <div>
        <h2 className="text-2xl font-semibold text-gray-800 mb-4">Treatment Applications</h2>
        <p className="text-gray-600 mb-6">
          Specify the number of herbicide applications and manual weeding operations needed.
        </p>
      </div>

      <div className="space-y-6">
        <div>
          <label className="block text-sm font-medium text-gray-700 mb-4">
            Number of Herbicide Applications
          </label>
          <div className="grid grid-cols-3 gap-4">
            {[1, 2, 3].map((num) => (
              <button
                key={num}
                type="button"
                onClick={() => updateFormData({ herbicideApplications: num })}
                className={`p-4 border rounded-lg flex flex-col items-center ${
                  formData.herbicideApplications === num
                    ? 'bg-green-50 border-green-500 text-green-700'
                    : 'border-gray-300 hover:bg-gray-50'
                }`}
              >
                <Droplets className="w-6 h-6 mb-2" />
                <span className="font-semibold">{num}</span>
                <span className="text-sm text-gray-600">
                  {num === 1 ? 'Application' : 'Applications'}
                </span>
              </button>
            ))}
          </div>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 mb-4">
            Number of Manual Weeding Operations
          </label>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[0, 1, 2, 3].map((num) => (
              <button
                key={num}
                type="button"
                onClick={() => updateFormData({ manualWeeding: num })}
                className={`p-4 border rounded-lg flex flex-col items-center ${
                  formData.manualWeeding === num
                    ? 'bg-green-50 border-green-500 text-green-700'
                    : 'border-gray-300 hover:bg-gray-50'
                }`}
              >
                <span className="text-2xl mb-2">👥</span>
                <span className="font-semibold">{num === 0 ? 'None' : num}</span>
                <span className="text-sm text-gray-600">
                  {num === 0 
                    ? 'No Manual Weeding' 
                    : num === 1 
                      ? 'Operation' 
                      : 'Operations'}
                </span>
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default HerbicideApplications;